import { render, staticRenderFns } from "./PaymentSteps.vue?vue&type=template&id=4b3cc279&scoped=true"
import script from "./PaymentSteps.vue?vue&type=script&lang=js"
export * from "./PaymentSteps.vue?vue&type=script&lang=js"
import style0 from "./PaymentSteps.vue?vue&type=style&index=0&id=4b3cc279&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3cc279",
  null
  
)

export default component.exports